import { render, staticRenderFns } from "./SurveyButton.partial.vue?vue&type=template&id=99c9e744&scoped=true"
import script from "./SurveyButton.partial.vue?vue&type=script&lang=js"
export * from "./SurveyButton.partial.vue?vue&type=script&lang=js"
import style0 from "./SurveyButton.partial.vue?vue&type=style&index=0&id=99c9e744&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c9e744",
  null
  
)

export default component.exports